export const colors = {
  primary: {
    main: '#5C85FF',
    light: '#DDE5FF',
    dark: '#CEDAFF',
    contrastText: '#FFFFFF',
  },

  secondary: {
    light: '#7382A9',
    main: '#D9DFED',//border color
    dark: '#51648F',//icon color
    contrastText: '#64759F',//textfield text color
  },

  custom: {
    light: '#ffa726',
    main: '#f57c00',
    dark: '#ef6c00',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },

  info: {
    main: '#82A6E0',
    light: '#D5E2F6',
    dark: '#43424c',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#FF8800',
    contrastText: '#FFE7CC',
    light: '#fbf0e4',
    dark: '#FFF3E5',
  },

  error: {
    main: '#D81010',
    dark: '#F61414',
    contrastText: '#FDD0D0',
    light: '#fdd0d0',
  },

  success: {
    light: '#D5ECBE',
    main: '#68CB00',
    dark:'#0EAB4E',
    contrastText: '#2A9D8F',
  },

  disabled: {
    light: '#9CA3B6',
    main: '#ebeef5',
    dark: '#434D67', //text color
    contrastText: '#BDC1CB',
  },

  transparent: {
    main: '#F8FAFB',
  },

  chipInfo: {
    dark: '#537EFF',
    light: '#eef2ff',
  },

  chipSuccess: {
    dark: '#0EAB4E',
    light: '#e7f7ed',
  },

  chipWarning:{
  dark: '#f78400',
  light:'#ffe5c8',
  },

  chipOnHold:{
   light: '#eaedf2',
  },

  machineNode:{
    main:'#8B85CB',
  },

  disabledColor:{
    dark:'#969696',
    light:'#e0e0e0',
    contrastText: '#444444',
  },
};
